class ReadMoreToggle {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation to handle both "Read more" and "Read less" buttons
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-read-more-toggle]')) {
        this.handleToggle(e);
      }
    });
  }

  handleToggle(event) {
    event.preventDefault();
    
    const button = event.target.closest('[data-read-more-toggle]');
    const container = button.closest('.read-more-container');
    const preview = container.querySelector('.read-more-preview');
    const fullText = container.querySelector('.read-more-full');
    const expandButton = preview.querySelector('[data-read-more-toggle]');
    const collapseButton = fullText.querySelector('[data-read-more-toggle]');
    
    if (!preview || !fullText || !expandButton || !collapseButton) {
      return;
    }
    
    // Check current state based on hidden attribute
    const isCurrentlyExpanded = !fullText.hasAttribute('hidden');
    
    if (isCurrentlyExpanded) {
      // Collapse: Show preview, hide full text
      preview.style.display = 'block';
      fullText.style.display = 'none';
      fullText.setAttribute('hidden', '');
      
      // Update ARIA states for collapsed state
      // Only the visible expand button should have aria-expanded="false"
      expandButton.setAttribute('aria-expanded', 'false');
      // The hidden collapse button doesn't need aria-expanded since it's not visible
      collapseButton.removeAttribute('aria-expanded');
      
      // Update aria-labelledby to point to the visible button
      fullText.setAttribute('aria-labelledby', expandButton.id);
      
    } else {
      // Expand: Hide preview, show full text  
      preview.style.display = 'none';
      fullText.style.display = 'block';
      fullText.removeAttribute('hidden');
      
      // Update ARIA states for expanded state
      // The hidden expand button doesn't need aria-expanded since it's not visible
      expandButton.removeAttribute('aria-expanded');
      // Only the visible collapse button should have aria-expanded="true"
      collapseButton.setAttribute('aria-expanded', 'true');
      
      // Update aria-labelledby to point to the visible button
      fullText.setAttribute('aria-labelledby', collapseButton.id);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ReadMoreToggle();
});

// Also initialize for dynamically loaded content (e.g., AJAX)
document.addEventListener('shopify:section:load', () => {
  new ReadMoreToggle();
});
